import {
    Injectable,
    Renderer,
    Renderer2,
} from '@angular/core';

import { Renderer3 } from '@angular/core/src/render3/renderer';

@Injectable()
export class RendererService {
    renderer: Renderer;
    renderer2: Renderer2;
    renderer3: Renderer3;
}



// WEBPACK FOOTER //
// ./client-src/app/core/services/rendererService.ts